import { httpRequest } from "../../http";
import { IngestConfigVersion } from "@models/configVersion.model";

export class CommandListConfigVersions {
  async run(definitionId: number): Promise<IngestConfigVersion[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/definitions/${definitionId}/config-versions/`;
    return httpRequest<IngestConfigVersion[]>(url, { method: "GET" });
  }
}
